import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { OkAloneService } from 'src/app/ok-alone.service';

@Component({
  selector: 'app-broadcasts-detail',
  templateUrl: './broadcasts-detail.component.html',
  styleUrls: ['./broadcasts-detail.component.scss']
})
export class BroadcastsDetailComponent implements OnInit, OnDestroy {

  broadcast: any;
  recipients: any[] = [];
  pagination = { page: 1, pageSize: 25, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };
  private socketSub?: Subscription;
  private broadcastId = 0;

  formGroup = new FormGroup({
    search: new FormControl(''),
    state: new FormControl(''),
  });

  constructor(
    public okService: OkAloneService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.broadcastId = Number(this.route.snapshot.paramMap.get('id'));
    this.loadBroadcast();
    this.loadRecipients();
    this.socketSub = this.okService.getBroadcastRefreshEmitter().subscribe(() => {
      this.loadBroadcast();
      this.loadRecipients();
    });
  }

  ngOnDestroy(): void {
    this.socketSub?.unsubscribe();
  }

  loadBroadcast(): void {
    this.okService.get('broadcasts/' + this.broadcastId, { expand: 'sender' }).subscribe((data) => {
      this.broadcast = data.body;
    });
  }

  loadRecipients(): void {
    const filter: any = {
      page: this.pagination.page,
      expand: 'worker,group',
      search: this.formGroup.value.search,
      state: this.formGroup.value.state,
    };
    Object.keys(filter).forEach((key) => {
      if (filter[key] === '' || filter[key] === null) {
        delete filter[key];
      }
    });

    this.okService.get('broadcasts/' + this.broadcastId + '/recipients', filter).subscribe((data) => {
      this.recipients = (data.body as any[]) || [];
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;
    });
  }

  updateFilter(): void {
    this.pagination.page = 1;
    this.loadRecipients();
  }

  changePage(): void {
    this.loadRecipients();
  }

  exportBroadcast(): void {
    this.okService.download('broadcasts/' + this.broadcastId + '/export', {});
  }

  back(): void {
    this.router.navigate(['/mgmt/broadcasts']);
  }

  statusBadgeClass(status: string): string {
    if (status === 'sent') {
      return 'bg-success';
    }
    if (status === 'sending') {
      return 'bg-warning text-dark';
    }
    return 'bg-secondary';
  }

  stateBadgeClass(state: string): string {
    switch (state) {
      case 'acknowledged':
        return 'bg-success';
      case 'read':
        return 'bg-info';
      case 'delivered':
        return 'bg-primary';
      case 'sent':
        return 'bg-secondary';
      case 'pending':
        return 'bg-light text-dark border';
      default:
        return 'bg-light text-dark border';
    }
  }

  initials(name: string): string {
    if (!name) {
      return '?';
    }
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  }
}
